import {
  useRef,
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';

import {
  polygonStyle,
} from '../../../constants';

import { getPolygonBounds } from '../../../helpers/gmaps';
import removeActiveShapes from '../../../helpers/removeActiveShapes';

const LocalityPolygonsTool = ({
  initialized,
  map,
  libraries,
  drawingData,
  totalListResults,
  setDrawingData,
  setInitialShapeForPrevious,
  setGeoFilters,
  setSaveSearchDrawingData,
}) => {
  const polygonRef = useRef([]);
  
  const [pathFromInit] = useState(drawingData.localityPolygons);

  const drawPolygon = (path, index, subindex) => {
    const {
      core: { LatLng, LatLngBounds },
      maps: { Polygon },
    } = libraries;

    const latLngPath = path.map((p) => p.map((node) => new LatLng({ lat: node[1], lng: node[0] })));

    if (subindex || subindex === 0) {
      if (!polygonRef.current[index]) {
        polygonRef.current[index] = [];
      }
      
      polygonRef.current[index][subindex] = new Polygon({ ...polygonStyle.complete, strokeOpacity: 1, strokeWeight: 2 });
      polygonRef.current[index][subindex].setPaths(latLngPath);
      polygonRef.current[index][subindex].setMap(map);
    } else {
      polygonRef.current[index] = new Polygon({ ...polygonStyle.complete, strokeOpacity: 1, strokeWeight: 2 });
      polygonRef.current[index].setPaths(latLngPath);
      polygonRef.current[index].setMap(map);
    }

    const newDrawingData = {
      ...drawingData,
      searchAddress: null,
      availableResults: { loading: false, value: totalListResults },
      activeShapes: [
        polygonRef.current,
      ],
      shapeBounds: getPolygonBounds(polygonRef.current, LatLngBounds),
      from: drawingData.action,
    };

    setInitialShapeForPrevious(newDrawingData);
    setDrawingData(newDrawingData);
  };

  const createInitialPolygon = ({ locs }) => {
    const { core: { LatLngBounds } } = libraries;

    if (drawingData.activeShapesToRemove) {
      removeActiveShapes({ drawingData, fromSSearch: true });
      setSaveSearchDrawingData(null);
    }

    locs.forEach((data, locIndex) => {
      if (data.type === 'MultiPolygon') {
        data.coordinates.forEach((subpath, pathIndex) => {
          drawPolygon(subpath, locIndex, pathIndex);
        });
      } else {
        drawPolygon(data.coordinates, locIndex);
      }
    });

    const polygonBounds = getPolygonBounds(polygonRef.current, LatLngBounds);

    if (drawingData?.fromBack) {
      const hkeys = (drawingData.localityHkeys || []).join(',');
      setGeoFilters({
        newfilter: {
          geopolygon: null,
          q: hkeys,
          geobounds: null,
          geocircle: null,
          nearby: null,
        },
      });
    }

    map.fitBounds(polygonBounds);
  };

  useEffect(() => {
    if (initialized && pathFromInit) {
      createInitialPolygon({ locs: pathFromInit });
    }
  }, [initialized, pathFromInit]);

  return null;
};

export default LocalityPolygonsTool;

LocalityPolygonsTool.propTypes = {
  initialized: PropTypes.bool,
  map: PropTypes.instanceOf(Object),
  libraries: PropTypes.instanceOf(Object),
  drawingData: PropTypes.instanceOf(Object),
  setDrawingData: PropTypes.func,
  setInitialShapeForPrevious: PropTypes.func,
  setGeoFilters: PropTypes.func,
  setSaveSearchDrawingData: PropTypes.func,
};

LocalityPolygonsTool.defaultProps = {
  initialized: false,
  map: null,
  libraries: null,
  drawingData: null,
  setDrawingData: () => {},
  setInitialShapeForPrevious: () => {},
  setGeoFilters: () => {},
  setSaveSearchDrawingData: () => {},
};
